import type { SettingMetadata } from "../../settings-catalog/types";
import { ReturnsFlatTeamSettingCatalogDefinitions as originalDefinitions } from "./catalog";

export const ReturnsFlatTeamSettingCatalogDefinitions = originalDefinitions.map(
  (definition) =>
    definition.id === "returns/shipping/verifyAddressForLabel"
      ? {
          ...definition,
          metadata: {
            ...definition.metadata,
            synonyms: definition.metadata.synonyms?.map((synonym) =>
              synonym === "address validation"
                ? "return shipping address validation"
                : synonym,
            ),
          },
        }
      : definition,
);

// eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
export const ReturnsFlatTeamSettingMetadataByKey = Object.fromEntries(
  ReturnsFlatTeamSettingCatalogDefinitions.map((definition) => [
    definition.id,
    definition.metadata,
  ]),
) as Record<(typeof originalDefinitions)[number]["id"], SettingMetadata>;
